import {axiosApi} from "@/js/axios";

const state = {
    contributions: [],
    perPage: 5,

    // Flags
    fetchingContributions: false,
};

const getters = {};

const actions = {
    fetchContributorContributions({state, commit, dispatch}, payload) {
        commit('SET_FETCHING_CONTRIBUTIONS', true);

        return new Promise((resolve, reject) => {
            axiosApi.get(`/api/v2/contributors/${payload.contributorId}/contributions`, {
                params: {
                    page: payload.page ? payload.page : 1,
                    perPage: state.perPage
                }
            }).then(({data}) => {
                if (data) {
                    commit('SET_CONTRIBUTIONS', data);
                    resolve(data)
                }
                commit('SET_FETCHING_CONTRIBUTIONS', false);
            }).catch(error => {
                commit('SET_FETCHING_CONTRIBUTIONS', false);
                reject(error);
            });
        });
    },
    fetchHazardContributions({state, commit, dispatch}, payload) {
        commit('SET_FETCHING_CONTRIBUTIONS', true);

        return new Promise((resolve, reject) => {

            let contributionType = ''
            if (payload.contributionType === 2) contributionType = 'hazards'
            if (payload.contributionType === 5) contributionType = 'incidents'
            if (payload.contributionType === 7) contributionType = 'terrorist-groups'

            axiosApi.get(`/api/v3/${contributionType}/${payload.hazardId}/contributions`, {
                params: {
                    contributionType: payload.contributionType,
                    page: payload.page ? payload.page : 1,
                    perPage: state.perPage
                }
            }).then(({data}) => {
                if (data) {
                    commit('SET_CONTRIBUTIONS', data);
                    resolve(data)
                }
                commit('SET_FETCHING_CONTRIBUTIONS', false);
            }).catch(error => {
                commit('SET_FETCHING_CONTRIBUTIONS', false);
                reject(error);
            });
        });
    },
};

const mutations = {
    SET_CONTRIBUTIONS(state, data) {
        state.contributions = data.items;
    },
    SET_FETCHING_CONTRIBUTIONS(state, value) {
        state.fetchingContributions = value;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/contribution.js